/**
 * Lokalt sparade "dockade" resultatpaneler för /results-visningswebben.
 * Varje panel är låst till ett meeting/event/split/klass och visar en topplista.
 */

export type ResultPanelConfig = {
    id: string;
    idMeeting: string;
    meetingTitle: string;
    eventKey: string;
    eventName: string;
    split: string;
    splitName: string;
    sex?: string;          // "M" | "W" | "X"
    ageGroup?: string;     // AgeGroup.key
    classLabel?: string;   // visningsetikett för vald klass, t.ex. "H45"
    count: number;         // antal rader i topplistan
};

const KEY = "results_panels_v1";

export const loadPanels = (): ResultPanelConfig[] => {
    try {
        const raw = localStorage.getItem(KEY);
        const arr = raw ? JSON.parse(raw) : [];
        return Array.isArray(arr) ? arr : [];
    } catch {
        return [];
    }
};

export const savePanels = (panels: ResultPanelConfig[]): void => {
    try {
        localStorage.setItem(KEY, JSON.stringify(panels));
    } catch {
        /* ignore */
    }
};

let seq = 0;
export const newPanelId = (): string => {
    seq += 1;
    return `p${Date.now().toString(36)}${seq}`;
};

/** Senast använda val i "Lägg till panel" (kom-ihåg för snabbare tillägg). */
export type LastWizardSelection = {
    idMeeting?: string;
    eventKey?: string;
    classValue?: string;
    count?: number;
};

const LAST_KEY = "results_wizard_last_v1";

export const loadLastSelection = (): LastWizardSelection => {
    try {
        const raw = localStorage.getItem(LAST_KEY);
        return raw ? JSON.parse(raw) : {};
    } catch {
        return {};
    }
};

export const saveLastSelection = (sel: LastWizardSelection): void => {
    try {
        localStorage.setItem(LAST_KEY, JSON.stringify(sel ?? {}));
    } catch {
        /* ignore */
    }
};
